/* eslint-disable no-undef */
import { useEffect, useRef, useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MapContext } from '@react-google-maps/api';
import NearmapCustomMapType from '../../property/map/NearmapCustomMapType';
import MapTypeConstant from '../../../constants/mapTypeConstant';
import Commons from '../../../helpers/Commons';

const NearmapTileLayer = ({ map: mapProp, mapTypeId, coverage, surveyId, coverageFetching }) => {
    const contextMap = useContext(MapContext);
    const map = mapProp ?? contextMap;
    const surveyRef = useRef(null);

    const ifUseCoverage = () => mapTypeId === MapTypeConstant.NEARMAP;

    useEffect(() => {
        if (!map) return;

        const clearMapLayer = () => {
            if (Commons.get(map, 'overlayMapTypes.clear')) {
                map.overlayMapTypes.clear();
            }
        };

        const insertLayer = (_surveyId) => {
            let mapTileLayer;
            if (_surveyId) {
                mapTileLayer = new NearmapCustomMapType(new google.maps.Size(256, 256), _surveyId);
            } else {
                mapTileLayer = new NearmapCustomMapType(new google.maps.Size(256, 256));
            }
            map.overlayMapTypes.insertAt(0, mapTileLayer);
        };

        if (ifUseCoverage()) {
            if (surveyId && surveyId !== surveyRef.current) {
                clearMapLayer();
                insertLayer(surveyId);
                surveyRef.current = surveyId;
            } else if (!surveyId) {
                clearMapLayer();
                insertLayer();
            }
        } else {
            clearMapLayer();
            insertLayer();
        }

        return () => clearMapLayer();
    }, [map, mapTypeId, surveyId]);

    return null;
};

NearmapTileLayer.propTypes = {
    map: PropTypes.object,
    mapTypeId: PropTypes.string,
    surveyId: PropTypes.string,
    coverage: PropTypes.array,
    coverageFetching: PropTypes.bool,
};

export default connect((state) => {
    const nearmap = state.map.get('nearmap');
    return {
        coverage: nearmap.coverage ? nearmap.coverage.surveys : null,
        surveyId: nearmap.selectedCoverage ? nearmap.selectedCoverage.id : null,
    };
})(NearmapTileLayer);
